export function getArrowId(fromAreaId, toAreaId) {
    return capitalize(`${fromAreaId} to ${toAreaId}`);
}

function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
